import Policy from './Policy';

export default Policy
export { Policy as Base }
